import {
  createStyles,
  Divider,
  Theme,
  Typography,
  withStyles,
} from '@material-ui/core'
import { WarningOutlined } from '@material-ui/icons'
import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { LocalizedWorkingStepLabel } from 'components/Localization/LocalizedWorkingStepLabel'
import { MoneyString } from 'model/Money'
import { TimeString } from 'model/Quantity'
import { useTranslation } from 'react-i18next'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { TargetPriceGraphData } from '../../useBomItemDetails'
import { TargetPriceTooltipListItemText } from './TargetPriceTooltipListItemText'

const WarningIcon = withStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.warning.main,
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
    },
  })
)(WarningOutlined)

export const WorkingStepSummaryTooltip = (props: {
  data: TargetPriceGraphData
}) => {
  const { t } = useTranslation()
  // console.log(props.data)
  return (
    <div style={{ textAlign: 'center' }}>
      <WorkingStepIconSvg
        workingStepType={props.data.primaryWorkingStep}
        attributes={{ width: '3em' }}
      />
      <Typography>{props.data.resource}</Typography>

      <LocalizedWorkingStepLabel
        workingStepType={props.data.primaryWorkingStep}
        variant="caption"
        component="p"
      />
      {props.data.primaryWorkingStep !== props.data.secondaryWorkingStep && (
        <LocalizedWorkingStepLabel
          workingStepType={props.data.secondaryWorkingStep}
          variant="caption"
          component="p"
          style={{ fontWeight: 'bold' }}
        />
      )}

      {props.data.sharedCost && (
        <Typography variant="caption" color="textSecondary">
          {`(${t('project:shared-cost', 'shared cost')})`}
        </Typography>
      )}
      <div style={{ textAlign: 'right' }}>
        {props.data.loading && (
          <TargetPriceTooltipListItemText
            secondary={MoneyString(props.data.loading)}
            primary={
              <LocalizedWorkingStepLabel
                workingStepType={WorkingStepType.Loading}
              />
            }
          />
        )}
        <TargetPriceTooltipListItemText
          secondary={TimeString(props.data.productionTime)}
          primary={t('project:production-time', 'production time')}
        />
        {props.data.setup && (
          <TargetPriceTooltipListItemText
            secondary={MoneyString(props.data.setup)}
            primary={
              <LocalizedWorkingStepLabel
                workingStepType={WorkingStepType.Setup}
              />
            }
          />
        )}
        <TargetPriceTooltipListItemText
          secondary={
            MoneyString(props.data.mainActivityCostPrice) || <WarningIcon />
          }
          primary={t('project:cost-price')}
        />
        {props.data.unloading && (
          <TargetPriceTooltipListItemText
            secondary={MoneyString(props.data.unloading)}
            primary={
              <LocalizedWorkingStepLabel
                workingStepType={WorkingStepType.Unloading}
              />
            }
          />
        )}
        <TargetPriceTooltipListItemText
          secondary={MoneyString(props.data.surchargeValue)}
          primary={t('common:surcharge')}
        />
        <TargetPriceTooltipListItemText
          secondary={`${MoneyString(props.data.discountValue)}`}
          primary={t('common:discount')}
          color="secondary"
        />
        <Divider style={{ margin: '0 -1rem' }} />

        <TargetPriceTooltipListItemText
          secondary={MoneyString(props.data.total)}
          primary={t('project:sales-price')}
        />
      </div>
      {/*





      {Object.keys(props.data)
        .filter((key) => key !== 'id' && key !== 'description')
        .map((d, index) => (
          <ListItemText
            key={`${props.data.description}-${d}-${index}`}
            primary={d}
            primaryTypographyProps={{
              variant: 'caption',
              color: 'textSecondary',
            }}
            secondary={MoneyString(props.data[d])}
            secondaryTypographyProps={{
              variant: 'body2',
              color: 'textPrimary',
            }}
          />
        ))} */}
    </div>
  )
}
